var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import InfoGraphic from "@/components/info-graphic";
import * as anime from "animejs";
var InfoGraphicRoeRoa = /** @class */ (function (_super) {
    __extends(InfoGraphicRoeRoa, _super);
    function InfoGraphicRoeRoa(el) {
        var _this = _super.call(this, el) || this;
        console.log("[create] InfoGraphicRoeRoa");
        return _this;
    }
    InfoGraphicRoeRoa.prototype._setAnimation = function () {
        window.innerWidth < 737
            ? this._setAnimaitonForSmall()
            : this._setAnimationForLarge();
        this._timeline.pause();
    };
    InfoGraphicRoeRoa.prototype._setAnimationForLarge = function () {
        this._timeline = anime
            .timeline()
            .add({
            targets: this._el.querySelectorAll("svg:nth-of-type(1) line"),
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: "easeInOutQuart",
            duration: 400,
            delay: function (el, i) {
                return i * 100;
            },
            direction: "alternate",
            loop: true,
        })
            .add({
            targets: this._el.querySelectorAll("svg:nth-of-type(1) .infographic__roe .infographic__line-chart"),
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: "linear",
            duration: 600,
            delay: function (el, i) {
                return i * 600;
            },
        })
            .add({
            targets: this._el.querySelectorAll("svg:nth-of-type(1) .infographic__roa .infographic__line-chart"),
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: "linear",
            duration: 600,
            delay: function (el, i) {
                return i * 600;
            },
            offset: "-=600",
        })
            .add({
            targets: this._el.querySelectorAll("svg:nth-of-type(1) .infographic__roe .infographic__num g"),
            translateY: ["-2%", "0%"],
            opacity: [0, 1],
            easing: "easeInOutQuart",
            duration: 400,
            delay: function (el, i) {
                return i * 100;
            },
            offset: "-=1600",
        })
            .add({
            targets: this._el.querySelectorAll("svg:nth-of-type(1) .infographic__roa .infographic__num g"),
            translateY: ["-2%", "0%"],
            opacity: [0, 1],
            easing: "easeInOutQuart",
            duration: 400,
            delay: function (el, i) {
                return i * 100;
            },
            offset: "-=1000",
        });
    };
    InfoGraphicRoeRoa.prototype._setAnimaitonForSmall = function () {
        this._timeline = anime
            .timeline()
            .add({
            targets: this._el.querySelectorAll("svg:nth-of-type(2) line"),
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: "easeInOutQuart",
            duration: 400,
            delay: function (el, i) {
                return i * 100;
            },
            direction: "alternate",
            loop: true,
        })
            .add({
            targets: this._el.querySelectorAll("svg:nth-of-type(2) .infographic__roe .infographic__line-chart"),
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: "linear",
            duration: 600,
            delay: function (el, i) {
                return i * 600;
            },
        })
            .add({
            targets: this._el.querySelectorAll("svg:nth-of-type(2) .infographic__roa .infographic__line-chart"),
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: "linear",
            duration: 600,
            delay: function (el, i) {
                return i * 600;
            },
            offset: "-=600",
        })
            .add({
            targets: this._el.querySelectorAll("svg:nth-of-type(2) .infographic__roe .infographic__num g"),
            translateY: ["-2%", "0%"],
            opacity: [0, 1],
            easing: "easeInOutQuart",
            duration: 400,
            delay: function (el, i) {
                return i * 100;
            },
            offset: "-=1600",
        })
            .add({
            targets: this._el.querySelectorAll("svg:nth-of-type(2) .infographic__roa .infographic__num g"),
            translateY: ["-2%", "0%"],
            opacity: [0, 1],
            easing: "easeInOutQuart",
            duration: 400,
            delay: function (el, i) {
                return i * 100;
            },
            offset: "-=1000",
        });
    };
    return InfoGraphicRoeRoa;
}(InfoGraphic));
export default InfoGraphicRoeRoa;
